import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import msalInstance from './services/Auth';

async function bootstrap() {
  const response = await msalInstance.handleRedirectPromise();

  if (response && response.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  const app = (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );

  ReactDOM.render(app, document.getElementById('root'));
  unregister();
}

bootstrap();


// WEBPACK FOOTER //
// ./src/index.js